import React from 'react';
import moment from 'moment';
import { Redirect  } from "react-router-dom";
import { convertMeterCommissionStatus } from '../../../../helpers/converters';

class MeterForms  extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    convertFormType = (type) => {
        switch(type) {
            case null : return null;
            case 'MeterCommission' : return "Meter Compliance Process";
            case 'MeterRegistration' : return "Meter Registration";
            case 'ValidationCert' : return "Validation Certificate";
            case 'DesignCert' : return "Design Certificate";
            case 'AccuracyCert' : return "Accuracy Certificate";
            case 'TransactionalArrangementsCert' : return "Transactional Arrangements Certificate";
            case 'MaintenanceValidationCert' : return "Maintenance Validation Certificate";
            default: return "Unknown"
        }
    }

    convertFormStatus = form => {

        if(form.type == 'MeterCommission') {
            return convertMeterCommissionStatus(form.formStatus)
        } else if(form.type == 'MeterRegistration') {
            switch(form.formStatus) {
                case 'DRAFT': return "Draft"
                case 'SUBMITTED': return "Submitted"
                case 'INSTALLED': return "Installed"
                case 'REMOVED': return "Removed"
                case 'PENDING_APPROVAL': return "Pending Approval"
                default : return "Unknown"
            }
        } else if(form.type == 'ValidationCert' || form.type == 'DesignCert' || form.type == 'AccuracyCert' || form.type == 'TransactionalArrangementsCert' || form.type == 'MaintenanceValidationCert') {
            switch(form.formStatus) {
                case 'DRAFT': return "Draft"
                case 'SUBMITTED': return "Submitted"
                default : return "Unknown"
            }
        } else {
            return 'Unknown'
        }
    }

    openForm =(form) => {
        if(form.type == 'MeterCommission') {
            this.setState({redirectTo:`/compliance-process/${form.id}/site-registration`});return;
        } else if(form.type == 'MeterRegistration') {
            window.location.href = `/NonUrbanRegistration?id=${form.id}`;
        } else if(form.type == 'ValidationCert') {
            window.location.href = `/validation-certificate-num?id=${form.id}`;
        } else if(form.type == 'DesignCert') {
            window.location.href = `/MeterDesignCertificate?id=${form.id}`;
        } else if(form.type == 'AccuracyCert') {
            window.location.href = `/accuracy-certificate-num?id=${form.id}`;
        } else if(form.type == 'TransactionalArrangementsCert') {
            window.location.href = `/TransitionalReporting?id=${form.id}`;
        } else if(form.type == 'MaintenanceValidationCert') {
            window.location.href = `/validation-certificate-num?id=${form.id}`;
        } 
    }

    linkForForm =(form) =>{
        if(form.type == 'MeterCommission') {
            return `/#/compliance-process/${form.id}/site-registration`;
        } else if(form.type == 'MeterRegistration') {
            return `/NonUrbanRegistration?id=${form.id}`;
        } else if(form.type == 'ValidationCert') {
            return `/validation-certificate-num?id=${form.id}`;
        } else if(form.type == 'DesignCert') {
            return `/MeterDesignCertificate?id=${form.id}`;
        } else if(form.type == 'AccuracyCert') {
            return `/accuracy-certificate-num?id=${form.id}`;
        } else if(form.type == 'TransactionalArrangementsCert') {
            return `/TransitionalReporting?id=${form.id}`;
        } else if(form.type == 'MaintenanceValidationCert') {
            return `/validation-certificate-num?id=${form.id}`;
        } 
        return null;
    }

    render() {
        const forms = this.props.forms;
        const meter = this.props.meter;
        return <>
            {this.state.redirectTo && <Redirect to={this.state.redirectTo}  />}
            <div class="table-responsive-xxl">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            
                            <th scope="col" style={{width:"180px"}}>Form Created</th>
                            <th scope="col" style={{width:"100px"}}>Form Id</th>
                            <th scope="col" style={{width:"250px"}}>Form Type</th>
                            <th scope="col" style={{width:"220px"}}>Installation Type</th>
                            <th scope="col" style={{width:"220px"}}>Form Status</th>
                            <th scope="col" ></th>
                        </tr>
                    </thead>
                    <tbody>
                        {forms.map(f=>{
                            return <tr>
                                
                                <td>{moment((new Date(f.createdDate))).format('DD/MM/YYYY')} </td>
                                <td>{f.id}</td>
                                <td>{this.convertFormType(f.type)} {(meter.createdByMeterCommissionId==f.id || meter.createdByMeterRegistrationId==f.id) && <span class="badge bg-info">Created This Meter</span>}</td>
                                <td>{f.installationType}</td>
                                <td>{this.convertFormStatus(f)}</td>
                                <td className='text-end'>
                                    <a className='btn btn-primary btn-sm' href={this.linkForForm(f)}>Open Form</a>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            

            
        </>
    }
}

export default MeterForms;
